import { render, staticRenderFns } from "./ConsultationTemp.vue?vue&type=template&id=b0bee91c&scoped=true"
import script from "./ConsultationTemp.vue?vue&type=script&lang=js"
export * from "./ConsultationTemp.vue?vue&type=script&lang=js"
import style0 from "./ConsultationTemp.vue?vue&type=style&index=0&id=b0bee91c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bee91c",
  null
  
)

export default component.exports